import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import {
    Checkbox,
    FormControlLabel,
    Grid,
    IconButton,
    TextField,
    Typography,
} from "@material-ui/core";
import { ControlledSelect } from "./controlledSelect";
import { makeStyles } from "@material-ui/core/styles";
import CircleUnchecked from "@material-ui/icons/RadioButtonUnchecked";
import CircleCheckedFilled from "@material-ui/icons/CheckCircle";
import React, { useCallback } from "react";
import CloseIcon from "@material-ui/icons/Close";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        maxWidth: 300,
    },
    fieldRow: {
        display: "flex",
        alignItems: "center",
        marginBottom: theme.spacing(2),
    },
    deleteButton: {
        padding: 0,
    },
    deleteButtonContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
    },
}));

function TemplateDialog({
    open,
    handleClose,
    data,
    onChange,
    handleFormSubmit,
    cfsFieldOptions,
    isEditing,
}) {
    const classes = useStyles();

    const handleDocusignFieldChange = useCallback(
        (index, value) => {
            onChange({
                target: {
                    id: "docusignField",
                    value,
                    index,
                },
            });
        },
        [onChange],
    );

    const handleCfsFieldChange = useCallback(
        (index, selectedOption) => {
            onChange({
                target: {
                    id: "cfsField",
                    value: {
                        _id: selectedOption.id,
                        name: selectedOption.name,
                    },
                    index,
                },
            });
        },
        [onChange],
    );

    const handleDeleteField = useCallback(
        (index) => {
            onChange({
                target: {
                    id: "deleteCfsTemplateField",
                    index,
                },
            });
        },
        [onChange],
    );

    return (
        <>
            <div>
                <Dialog open={open} onClose={handleClose}>
                    <DialogTitle id="metadata-dialog-title">
                        {isEditing ? "Update Template" : "Create Template"}
                    </DialogTitle>
                    <form onSubmit={handleFormSubmit}>
                        <DialogContent>
                            <Typography variant="subtitle1" component="p">
                                Please fill out the information below and
                                submit.
                            </Typography>
                            <br />
                            <TextField
                                required={true}
                                type="text"
                                id="name"
                                value={data.name.value}
                                onChange={(e) => onChange(e)}
                                placeholder={`Enter Template Name`}
                                label={"Template Name"}
                                variant="outlined"
                                margin="dense"
                                fullWidth
                            />
                            <TextField
                                required={true}
                                type="text"
                                id="docusignTemplateId"
                                value={data.docusignTemplateId.value}
                                onChange={(e) => onChange(e)}
                                placeholder={`Enter Docusign Template ID`}
                                label={"Docusign Template ID"}
                                variant="outlined"
                                margin="dense"
                                fullWidth
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(e) =>
                                            onChange({
                                                target: {
                                                    id: "isActive",
                                                    value: e.target.checked,
                                                },
                                            })
                                        }
                                        id="isActive"
                                        checked={Boolean(data.isActive.value)}
                                        icon={<CircleUnchecked />}
                                        checkedIcon={<CircleCheckedFilled />}
                                    />
                                }
                                label="Active"
                            />
                            <Grid container spacing={2}>
                                {data.cfsTemplateFields.value.map(
                                    (
                                        { docusignField, cfsField },
                                        index,
                                        { length },
                                    ) => {
                                        return (
                                            <>
                                                <Grid item xs={5}>
                                                    <TextField
                                                        required={true}
                                                        type="text"
                                                        id={`docusign_${docusignField}`}
                                                        value={docusignField}
                                                        onChange={(e) =>
                                                            handleDocusignFieldChange(
                                                                index,
                                                                e.target.value,
                                                            )
                                                        }
                                                        placeholder={`Enter Docusign Field`}
                                                        label={"Docusign Field"}
                                                        variant="outlined"
                                                        margin="dense"
                                                        fullWidth
                                                    />
                                                </Grid>
                                                <Grid item xs={5}>
                                                    <ControlledSelect
                                                        label="CFS Field"
                                                        id={cfsField._id}
                                                        value={cfsField._id}
                                                        options={cfsFieldOptions.map(
                                                            (option) => ({
                                                                value: option.id,
                                                                label: option.name,
                                                            }),
                                                        )}
                                                        onChange={(e) => {
                                                            const selectedOption =
                                                                cfsFieldOptions.find(
                                                                    (option) =>
                                                                        option.id ===
                                                                        e.target
                                                                            .value,
                                                                );
                                                            handleCfsFieldChange(
                                                                index,
                                                                selectedOption,
                                                            );
                                                        }}
                                                        hasError={false}
                                                    />
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <div
                                                        className={
                                                            classes.deleteButtonContainer
                                                        }
                                                    >
                                                        <IconButton
                                                            className={
                                                                classes.deleteButton
                                                            }
                                                            onClick={() =>
                                                                handleDeleteField(
                                                                    index,
                                                                )
                                                            }
                                                        >
                                                            <CloseIcon />
                                                        </IconButton>
                                                    </div>
                                                </Grid>
                                            </>
                                        );
                                    },
                                )}
                            </Grid>
                            <div
                                style={{
                                    marginBottom: "5px",
                                    display: "block",
                                }}
                            ></div>
                            <div
                                style={{
                                    marginTop: "16px",
                                    marginBottom: "16px",
                                }}
                            >
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    startIcon={<AddCircleOutlineIcon />}
                                    onClick={() => {
                                        onChange({
                                            target: {
                                                id: "addCfsTemplateField",
                                            },
                                        });
                                    }}
                                >
                                    Add CFS-Docusign Field
                                </Button>
                            </div>

                            <DialogActions>
                                <Button
                                    onClick={handleClose}
                                    color="secondary"
                                    variant="outlined"
                                >
                                    Cancel
                                </Button>
                                <Button
                                    type="submit"
                                    color="primary"
                                    variant="contained"
                                >
                                    Submit
                                </Button>
                            </DialogActions>
                        </DialogContent>
                    </form>
                </Dialog>
            </div>
            <style>
                {`
          .drag-handle {
            cursor: move;
            color: #999;
          }
          .ag-row-drag {
            display: none;
          }
        `}
            </style>
        </>
    );
}

export default TemplateDialog;
